module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_8003.589eaa24.png";